<template>
    <div>
        <div v-show="!isLoading">
            <div v-show="false">{{ value }}</div>
            <!-- Revert link -->
            <div v-if="revertLink && Object.keys(revertLink).length" class="mb bottom align-right">
                <a href="#" @click.prevent="revertCommonTemplate" :class="{ 'is-loading': isRevertLoading }">
                    {{ revertLink.title }}
                </a>
            </div>
            <textarea :id="`textarea-editor-`+id" class="width100 textarea-ace-editor" :value="dataList.template" @input="onInput"></textarea>
            <div :id="`js-redactor-block-`+id"></div>
        </div>

    </div>
</template>

<script>
    import qs from "qs";

    export default {
        name: "BaseEditTemplate",
        props: {
            id: {
                type: String,
                required: true
            },
            revertLink: Object,
            url: String,
            postData: Object,
            value: String|Number
        },
        data() {
            return {
                isLoading: true,
                isRevertLoading: false,
                scriptsLoaded: false,
                dataList: {
                    template: ''
                },
                mergedPostData: {},
                mergedRevertLink: {},
                defaultPostData: {
                    _csrf: this.csrf
                },
                defaultRevertLink: {
                    postData: {},
                    _csrf: this.csrf
                },
                waitAceScriptLoadedTimes: 10
            }
        },
        created() {
            this.loadScripts();
        },
        mounted() {
            this.dataList.template = this.value;
            this.scriptsLoaded && this.initEditor();
            this.mergedPostData = this.getPostData;
            this.mergedRevertLink = this.getRevertLink;
        },
        updated() {
            const self = this;
            this.$nextTick(function () {
                if (self.value !== undefined) {
                    self.dataList.template = self.value;
                }
            });
        },
        destroyed() {
            setTimeout(() => {
                $('.textarea-ace-editor').each(function () {
                    $(this).trigger('editorDataUpdated');
                })
            }, 50);
        },
        computed: {
            getPostData() {
                return {
                    ...this.postData,
                    ...this.defaultPostData
                }
            },
            getRevertLink() {
                return {
                    ...this.revertLink,
                    ...this.defaultRevertLink
                }
            }
        },
        methods: {
            onInput(e) {
                this.$emit('input', e.target.value);
            },

            initEditor() {
                const self = this;

                // This is bullshit..
                if (typeof waEditorAceInit === 'undefined' && this.waitAceScriptLoadedTimes > 0) {
                    setTimeout(() => {
                        this.waitAceScriptLoadedTimes--;
                        self.initEditor();
                    }, 100);
                    return;
                }

                const textareaId = "textarea-editor-" + this.id,
                    redactorId = "js-redactor-block-" + this.id;

                const $redactor = $("#js-redactor-block-" + this.id);
                const $textarea = $("#textarea-editor-" + this.id);

                waEditorAceInit({
                    "id": textareaId,
                    "ace_editor_container": redactorId,
                    change_callback: function () {
                        $(document).trigger("updateEditorTextarea" + self.id);
                    }
                });

                if (typeof wa_editor !== "undefined") {
                    $redactor.data("wa_editor", wa_editor);
                }

                $textarea.data('wa_editor', $redactor.data('wa_editor'));

                $textarea.off("editorDataUpdated").on("editorDataUpdated", function () {
                    const editor = $redactor.data("wa_editor");
                    if (editor) {
                        editor.setValue($textarea.val());
                        editor.clearSelection();
                    }
                });

                $(document).off("updateEditorTextarea" + self.id).on("updateEditorTextarea" + self.id, function () {
                    const editor = $redactor.data("wa_editor");
                    if (editor) {
                        const data = editor.getValue();
                        $textarea.val(data).trigger("change");
                        self.$emit('input', data);
                    }
                });

                this.$emit('loaded');
            },
            /* Восстановить оригинальный шаблон */
            revertCommonTemplate() {
                const self = this;

                if (!self.isRevertLoading) {
                    self.isRevertLoading = true;
                    self.$http.post(
                        self.revertLink.url,
                        qs.stringify(self.mergedRevertLink), { headers: { 'content-type': 'application/x-www-form-urlencoded' } }
                    ).then(function (response) {
                        self.dataList['template'] = response.data.data;
                        self.$emit('input', self.dataList['template']);
                        setTimeout(() => {
                            $("#textarea-editor-" + self.id).trigger('editorDataUpdated');
                        }, 10);
                    }).finally(function () {
                        self.isRevertLoading = false;
                    })
                }
            },
            loadScripts() {
                const self = this;

                /* Подгрузка скриптов редактирования */
                const loadScripts = self.$loadScript.series([
                    window.wa_url + 'wa-content/js/ace/ace.js',
                    window.wa_url + 'wa-content/js/jquery-wa/editor2.js',
                    window.wa_url + 'wa-content/js/jquery-wa/wa.elrte.ace.js'
                ]);
                loadScripts.then(() => {
                    self.scriptsLoaded = true;
                    if (self.content !== undefined) {
                        self.dataList['template'] = self.content;
                    }
                    self.$emit('input', self.dataList['template']);
                    /* Подгружаем шаблон, если указан URL */
                    if (self.url) {
                        self.$http.post(self.url,
                            qs.stringify(self.mergedPostData), { headers: { 'content-type': 'application/x-www-form-urlencoded' } }
                        ).then(function (response) {
                            self.dataList['template'] = response.data.data;
                            self.$emit('input', self.dataList['template']);
                        }).finally(function () {
                            self.isLoading = false;
                            self.initEditor();
                        });
                    } else {
                        self.initEditor();
                        self.isLoading = false;
                    }
                });
            }
        }
    }
</script>